import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Examples showing how to easily build a rich variety of interactive document applications with `}<inlineCode parentName="p">{`unified-doc`}</inlineCode></p>
    <ul>
      <li parentName="ul"><Link to='./doc-preview' mdxType="Link">Doc preview</Link></li>
      <li parentName="ul"><Link to='./file-system' mdxType="Link">File system</Link></li>
      <li parentName="ul"><Link to='./diff' mdxType="Link">Diff</Link></li>
      <li parentName="ul"><Link to='./ebook' mdxType="Link">Ebook</Link></li>
      <li parentName="ul"><Link to='./esignature' mdxType="Link">ESignature</Link></li>
      <li parentName="ul"><Link to='./docx' mdxType="Link">Docx</Link></li>
      <li parentName="ul"><Link to='./pdf' mdxType="Link">Pdf (experimental)</Link></li>
      <li parentName="ul"><Link to='./epub' mdxType="Link">Epub (experimental)</Link></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      